import React from 'react';
import CategoryWiseReportsHeader from '../CategoryWiseReportsHeader';
import CategoryWiseReportsContent from '../CategoryWiseReportsContent';

const CategoryWiseReports = () => {
    return (
        <>
            <CategoryWiseReportsHeader />
            <CategoryWiseReportsContent />
        </>
    );
};

export default CategoryWiseReports;

